import {
  ExecutiveData,
  ExecutiveRegionalData,
  RegionalData,
  DistrictData,
  DistributorData,
  AgentData,
  CustomerData,
  ProductData,
  ProductGroupData,
  DistrictProductData,
  DistrictProductGroupData,
  AgentProductData,
  AgentProductGroupData,
  DefaultData,
  TradeTeamData,
} from "./visualizations";

export function AccessComponentFactory(type, role, empAccess = null) {
  let dataMap = {
    5: ExecutiveData,
    2: DistrictData,
    1: AgentData,
    4: empAccess == 5 ? ExecutiveRegionalData : RegionalData,
    3: DistributorData,
    8: CustomerData,
    9:
      empAccess === 2
        ? DistrictProductGroupData
        : empAccess === 1
          ? AgentProductGroupData
          : ProductGroupData,
    10:
      empAccess === 2
        ? DistrictProductData
        : empAccess === 1
          ? AgentProductData
          : ProductData,
    11: TradeTeamData,
    "-1": DefaultData,
  };

  return dataMap[role]?.[type] || DefaultData;
}
